export default {
  UTF16: 'utf-16',
  URI: 'EncodedURIComponent',
};
